import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdateWarehouse($companyId: ID!, $id: ID!, $attributes: WarehouseAttributes!) {
    updateWarehouse(companyId: $companyId, id: $id, attributes: $attributes) {
      warehouse {
        id
        ...UpdatedWarehouse
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedWarehouse on Warehouse {
    id
    name
    address
    address1
    address2
    address3
    city
    county
    postcode
  }
`
